import type { BoxShadows, ImageBlockFragment } from '@seek/cmsu-cms-connect';
import { vars } from 'braid-design-system/css';

import { nonBraidColourMap } from '../../shared/helper';

/**
 * We want to get the key,
 * At the moment, some of the enums have `border` in the name, so we need to remove it
 * because we want to match it to the `vars.borderColor` object
 * https://seek-oss.github.io/braid-design-system/css/vars#vars.bordercolor
 * @param blockBorder
 * @returns
 */
const getBorderColorKey = (
  blockBorder?: BoxShadows | null,
): keyof typeof vars.borderColor | undefined => {
  if (!blockBorder) {
    return undefined;
  }
  const cleaned = blockBorder.replaceAll('border', '').trim();
  if (!cleaned) {
    return undefined;
  }
  const key = cleaned.charAt(0).toLowerCase() + cleaned.slice(1);
  return key as keyof typeof vars.borderColor;
};

/**
 * When using this function, apply it to the style prop as the last parameter
 * @param accentBar
 * @param blockBorder
 * @returns
 */
export const getAccentBarStyle = (
  accentBar?: ImageBlockFragment['accentBar'],
  blockBorder?: BoxShadows | null,
): string | undefined => {
  if (!accentBar) {
    return undefined;
  }

  const borderColorKey = getBorderColorKey(blockBorder);
  const accentBarColorKey = accentBar as keyof typeof vars.borderColor;

  const borderStyle = borderColorKey
    ? `inset 0 0 0 ${vars.borderWidth.standard} ${vars.borderColor[borderColorKey]}, `
    : '';

  const accentBarStyle = `inset 40px 0 0 calc(-35px + ${
    vars.borderWidth.standard
  }) ${
    vars.borderColor[accentBarColorKey] ||
    nonBraidColourMap[accentBar]?.tone ||
    'transparent'
  }`;

  return `${borderStyle}${accentBarStyle}`;
};
